<template>
  <gg-card>
    <gg-card-header>
      Migration #{{ migration.id }}
    </gg-card-header>
    <gg-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">
              Service
            </th>
            <th class="text-left">
              Status
            </th>
            <th class="text-left">
              Event title
            </th>
            <th class="text-left">
              Source
            </th>
            <th class="text-left">
              Destination
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              {{ migration.service_name }}
            </td>
            <td>
              {{ migration.status }}
            </td>
            <td>
              {{ migration.event_title }}
            </td>
            <td>
              {{ migration.source_server }}
            </td>
            <td>
              {{ migration.destination_server }}
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </gg-card-text>
  </gg-card>
</template>

<script>
export default {
  name: 'MigrationDetailsCard',
  props: {
    migration: {
      type: Object,
      required: true
    }
  }
}
</script>
